import React from 'react';
import { Icon } from './Icon.js';
export const IconCircleBolt = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M13.5 10.5L17 11V11.5L12 18H11L10.5 13.5L7 13V12.5L12 6H13L13.5 10.5Z", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", fill: "none" })));
};
//# sourceMappingURL=IconCircleBolt.js.map